module.exports = __webpack_public_path__ + "media/ads/black_friday-c151adab.png";